const apiConstant = {
  login: "/auth/login",
  loginSocial: "auth/login/social",
  register: "/auth/signup",
  requestEmailVerify: "/auth/email/request",
  emailVerify: "/auth/email/verify",
  profile: "/users/profile",
  getAllUsersAdmin: "/admin/users",
  updateUserByAdmin: "/admin/user",
  deleteUserByAdmin: "/admin/user",
  forgot: "/auth/password/forgot",
  resetPassword: "/auth/password/reset",
  projects: "/projects",
  generateSignedUrl: "/storage/upload",
  changePassword: "/users/password",
  searchMembers: (arg) => `/members/search?search=${arg}`,
  projectsById: (arg1, arg2, arg3, arg4) =>
    `/projects/${arg1}?members=${arg2}&milestones=${arg3}&page=${arg4}`,
  fcm: "/users/fcm",
  updateProject: (projectId) => `/projects/${projectId}`,
  archive: "/projects/archive",
  notifications: "/notifications",
  unreadNotificationsCount: "/notifications/unread/count",
  deleteMember: "/members/delete",
  getMilestone: (arg1, arg2, arg3, arg4) =>
    `/milestones/project/${arg1}?status=${arg2}&search=${arg3}&page=${arg4}`,
  milestoneView: ({
    milestoneId,
    page = 1,
    type = "",
    search = "",
    status = "",
    assignee = "",
  }) =>
    `/milestones/${milestoneId}?page=${page}&type=${type}&search=${search}&status=${status}&assignee=${assignee}&limit=10`,
  milestoneIssues: ({
    milestoneId,
    page = 1,
    type = "",
    search = "",
    status = "",
    assignee = "",
  }) =>
    `/issues/milestone/${milestoneId}?page=${page}&type=${type}&search=${search}&status=${status}&assignee=${assignee}&limit=10`,
  issueMembersSearch: "/issues/members/search",
  createMilestone: "/milestones",
  getIssueDetails: (issueId) => `/issues/${issueId}`,
  createIssue: "/issues",
  updateMilestone: ({ milestoneId }) => `/milestones/${milestoneId}`,
  deleteMilestone: ({ milestoneId }) => `/milestones/${milestoneId}`,
  updateIssueDetails: (issueId) => `/issues/${issueId}`,
  deleteIssue: (issueId) => `/issues/${issueId}`,
  getIssueActivities: ({ issueId, page = 1 }) =>
    `/activities/${issueId}?page=${page}`,
  updateActivity: ({ activityId }) => `/activities/${activityId}`,
  deleteActivity: ({ activityId }) => `/activities/${activityId}`,
  addActivity: `/activities/`,
  getPublicProject: (projectId, publicId) =>
    `/projects/public/${projectId}/${publicId}`,
  getPublicMilestones: ({ projectId, page = 1, status = "" }) =>
    `/milestones/public/project/${projectId}?page=${page}&status=${status}`,
  getPublicIssues: ({ milestoneId, status = "", assignee = "" }) =>
    `/issues/public/milestone/${milestoneId}?status=${status}&assignee=${assignee}`,
  archivedProjects: "/projects/archived",
  getProjectMembers: (projectId, page) => `/members/${projectId}?page=${page}`,
  regenerateKey: "/users/key/regenerate",
  markAsRead: "/notifications/read",
  globalSearch: "/search/global",
  getMilestoneActivityTimeline: ({ milestoneId, page = 1 }) =>
    `activities/milestones/${milestoneId}?page=${page}&perPage=15`,
};

export default apiConstant;
